import React from "react";
import { Calendar } from "lucide-react";

export default function LeadRemindersCard({ reminders, onAddClick, onComplete }) {
  return (
    <div className="bento-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-medium text-[#1C1917]" style={{ fontFamily: "Playfair Display, serif" }}>
          Follow Up Reminders
        </h2>
        <button onClick={onAddClick} className="btn-secondary flex items-center gap-2" data-testid="add-reminder-btn">
          <Calendar size={16} /> Add Follow Up
        </button>
      </div>

      {reminders.length === 0 ? (
        <div className="text-center text-[#A8A29E] py-6">
          <Calendar size={32} className="mx-auto mb-2" />
          <p>No follow-ups scheduled</p>
        </div>
      ) : (
        <div className="space-y-2">
          {reminders.map((reminder) => (
            <div
              key={reminder.id}
              className={`flex items-center justify-between p-3 rounded-md ${reminder.completed ? "bg-[#F5F2EA] opacity-60" : "bg-[#FEF3C7]"}`}
              data-testid={`reminder-${reminder.id}`}
            >
              <div>
                <p className={`font-medium ${reminder.completed ? "line-through text-[#A8A29E]" : "text-[#1C1917]"}`}>
                  {reminder.message}
                </p>
                <p className="text-sm text-[#57534E]">
                  {new Date(reminder.reminder_date).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                </p>
              </div>
              {!reminder.completed && (
                <button onClick={() => onComplete(reminder.id)} className="btn-ghost text-sm" data-testid={`complete-reminder-${reminder.id}`}>
                  Mark Done
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
